// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d67a584e","44":"19e5e3b0","165":"4d618aeb","267":"78cfd482","319":"013dbb67","488":"a63b9016","532":"d4f73a63","636":"81021351","668":"a626330f","717":"b075d39d","742":"2f0fde0f","796":"8417f8a7","822":"7ea54097","879":"b0d25069","925":"94b2eb72","973":"a92b4d89"}[chunkId] + ".chunk.js";
};